import { AuthContext } from '@/types/stores/auth';
import { jwtDecode } from 'jwt-decode';

export function decodeAuthToken(token: string): AuthContext {
  const decoded: any = jwtDecode(token);

  return {
    userId: decoded.sub,
    groupId: decoded.groupId,
    membershipRoles: decoded.membershipRoles,
    authenticationLevel: decoded.acr,
    age: decoded.age,
  };
}
